// src/api/api.js
import api from "./axiosConfig";

// Generic GET request
export const getRequest = async (endpoint, config = {}) => {
  try {
    const response = await api.get(endpoint, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// Generic POST request
export const postRequest = async (endpoint, data, config = {}) => {
  try {
    const response = await api.post(endpoint, data, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

// ✅ Generic DELETE request
export const deleteRequest = async (endpoint, config = {}) => {
  try {
    const response = await api.delete(endpoint, config);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
